<template>
    <div class="inputs">
        <field-input v-model="form.trigger" placeholder="Trigger"></field-input>
        <search-user v-model="form.employer_id" filter="employers" placeholder="Employer" ></search-user>
        <search-user v-model="form.technician_id" filter="technicians" placeholder="Technician" @user="updateUser"></search-user>
        <div v-if="form.technician_id">
            <auditable-project class="mb-3" v-model="form" prefix-url="/desk-audits" @project="updateProject"></auditable-project>
            <field-select v-model="form.type" placeholder="Type">
                <option value="certificate">Certificate</option>
                <option value="recertificate">Recertificate</option>
                <option value="random">Random</option>
            </field-select>
        </div>
    </div>
</template>
<script>
    export default {

        props: {
            form: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                deskAudit: this.form
            }
        },

        methods: {
            updateUser(user) {
                this.deskAudit['technician'] = user;
            },

            updateProject(project){
                this.deskAudit.project_id = project.id;
            }
        }
    }
</script>
